import { useLoadableRemoteConfig } from '@hackler/react-sdk'
import { useEffect } from 'react'
import Cookies from 'universal-cookie'
import { useBasicPopup } from '../../../components/basic/popup/BasicPopup'
import RemoteConfigPopupBody from '../../../components/common/RemoteConfigPopupBody'
import { useCurrentUser } from '../../context/UserContext'
import { isB2BHRGroup, isMulticampus } from '../../utils'
import useAppRouter from './useAppRouter'
import useIsMobile from './useIsMobile'

export const usePopupData = (remoteConfig) => {
  const data = JSON.parse(remoteConfig.get('plus_popup', 'null'))

  if (data) {
    return data.case[0] || {}
  }

  return null
}

export enum PROMO_POPUP_HIDE_DURATION {
  ONE_DAY = 'one_day',
  ONE_WEEK = 'one_week',
  ONE_MONTH = 'one_month',
}

const useRemoteConfigPopup = () => {
  const router = useAppRouter()
  const basicPopup = useBasicPopup()
  const isMobile = useIsMobile()
  const cookies = new Cookies()
  const { isLoading, remoteConfig } = useLoadableRemoteConfig()
  const { currentUser } = useCurrentUser()
  const popupData = usePopupData(remoteConfig)

  useEffect(() => {
    if (isB2BHRGroup(currentUser) || isMulticampus(currentUser)) return
    if (!popupData || isLoading) return

    const hasUserClosedPopup: string = cookies.get(`is_closed_popup_${popupData.id}`)
    if (hasUserClosedPopup !== undefined && Number(hasUserClosedPopup)) return

    const notEnableUrl = !popupData?.enabled_url_list.some((path) => router.asPath.includes(path))
    const now = new Date()
    const startDate = new Date(popupData.display_period.start_date)
    const endDate = new Date(popupData.display_period.end_date)

    if (now >= startDate && now <= endDate) {
      if (popupData.enabled && !notEnableUrl) {
        basicPopup.show({
          id: popupData.id,
          maxW: isMobile ? 400 : 464,
          maxH: isMobile ? 520 : 618,
          bodyPb: 0,
          bodyPx: 0,
          noTitle: true,
          noClose: true,
          body: <RemoteConfigPopupBody popupData={popupData} />,
        })
      }
    }
  }, [popupData, isLoading, currentUser])
}

export default useRemoteConfigPopup
